// import { useEffect, useState } from 'react';
// import { useAppDispatch } from '@store/hooks';
// import { useFormik } from 'formik';
// import { useTranslation } from 'react-i18next';
// import { Form } from 'react-bootstrap';
// import Breadcrumb from '@components/Shared/Breadcrumb';
// import useGetGlJeCategoryList from '@hooks/Finance/useGetGlJeCategoryList';
// import useGetGlJeSourceList from '@hooks/Finance/useGetGlJeSourceList';
// import useGetGlLedgersList from '@hooks/Finance/useGetGlLedgersList';
// import useGetGlPeriodsList from '@hooks/Finance/GlPeriods/useGetGlPeriodsList';
// import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
// import { useNavigate, useParams } from 'react-router-dom';
// import { type LedgersModels } from '@store/Finance/Ledgers/LedgersModels';
// import { type GlJeLinesList } from '@store/Finance/Journals/JournalsModels';
// import { AddGlJeHeaders } from '@store/Finance/Journals/JournalsSlice';
// import CustomAlert from '@components/Shared/Alert/CustomAlert';
// import SwalAlert from '@components/Shared/Alert/SwalAlert';
// import { AddGlJeHeaderSchema } from '../../../ValidationForm/validationSchema';
// import JournalLines2 from '../JournalLines/JournalLines2';
// import { Card, CardBody, CardFooter } from '@components/card/card';
// import useConversionRateByLedgard from '@hooks/Finance/DailyRates/useConversionRateByLedgard';
// import useCheckDateOnPeriod from '@hooks/Finance/GlPeriods/useCheckDateOnPeriod';
// import Loading from '@components/Shared/Loader/Loading';

// const AddJournals = () => {
//   const navigate = useNavigate();
//   const { i18n, t } = useTranslation();
//   const [stateJu, setStateJu] = useState<string>('T');
//   const dispatch = useAppDispatch();
//   const { Currency, loading: loading1, error: error1 } = useLookupCurrency();
//   const { GlJeCategoryList, loading: loading2, error: error2 } = useGetGlJeCategoryList();
//   const { GlJeSourceList, loading: loading3, error: error3 } = useGetGlJeSourceList();
//   const { LedgersList, loading: loading4, error: error4 } = useGetGlLedgersList();
//   const { PeriodsList, GlPeriods, loading: loading5, error: error5 } = useGetGlPeriodsList();
//   const { ledgerId } = useParams();
//   const [ledgar, setLedgar] = useState<LedgersModels | undefined>(undefined);

//   useEffect(() => {
//     if (LedgersList && ledgerId) {
//       const foundLedger = LedgersList?.find(ledger => ledger.id === ledgerId);
//       if (foundLedger) {
//         setLedgar(foundLedger);
//       }
//     }
//   }, [LedgersList]);

//   //#region Formik
//   const formik = useFormik({
//     initialValues: {
//       glDate: new Date().toISOString().split('T')[0],
//       ledgerId: ledgerId,
//       jeCategory: '',
//       jeSource: '',
//       periodId: '',
//       name: 'manual +  periodId + jeCategory + jeSource', // لا يظهر في الشاشة هو تحميع حقول مع بعض
//       status: '', // temp | unpost

//       currencyCode: ledgar ? ledgar?.currencyCode : 'SAR',
//       conversionFlag: false,
//       currencyConversionRate: 1,
//       conversionDate: '', // date يأتي تلقائي من جدول الrate
//       ///
//       reverseFlag: false,
//       jeBatchId: null,
//       parentJeHeaderId: null,
//       postedDate: '',
//       description: '',
//       accountedDr: 0,
//       accountedCr: 0,
//       enteredDr: 0,
//       enteredCr: 0,
//       JeLinesList: [] as GlJeLinesList[]
//     },
//     enableReinitialize: true,
//     validationSchema: AddGlJeHeaderSchema(t),
//     onSubmit: values => {
//       if (values.JeLinesList?.length === 0) {
//         SwalAlert({ text: 'There is no Data' });
//         formik.setSubmitting(false);
//         return;
//       }

//       if (!isDateValid) {
//         SwalAlert({ text: 'التاريـخ ليس ضمن الفترة المحاسبية' });
//         formik.setSubmitting(false);
//         return;
//       }

//       if (stateJu === 'U' && Number(totalEnteredDr) !== Number(totalEnteredCr)) {
//         SwalAlert({ text: 'يجب ان يتساوى الدائن والمديـن' });
//         formik.setSubmitting(false);
//         return;
//       }

//       dispatch(
//         AddGlJeHeaders({
//           glDate: values.glDate,
//           ledgerId: values.ledgerId || '',
//           jeCategory: values.jeCategory,
//           jeSource: values.jeSource,
//           periodId: values.periodId,
//           name: getNameJournals(),
//           status: stateJu,
//           currencyCode: values.currencyCode,
//           conversionFlag: values.currencyCode !== ledgar?.currencyCode,
//           currencyConversionRate: conversionRate,
//           // conversionDate: values.currencyCode !== ledgar?.currencyCode ? conversionDate : null,
//           conversionDate: null,
//           ///
//           jeBatchId: values.jeBatchId,
//           parentJeHeaderId: values.parentJeHeaderId,
//           postedDate: new Date().toISOString().split('T')[0],
//           description: values.description,
//           accountedDr: Number(totalAccountedDr),
//           accountedCr: Number(totalAccountedCr),
//           enteredDr: Number(totalEnteredDr),
//           enteredCr: Number(totalEnteredCr),
//           glJeLinesList: values.JeLinesList?.map(item => ({
//             jeLineNum: Number(item.jeLineNum),
//             enteredDr: Number(item.enteredDr) || 0,
//             enteredCr: Number(item.enteredCr) || 0,
//             accountDr: Number(item.accountDr) || 0,
//             accountCr: Number(item.accountCr) || 0,
//             description: item.description,
//             accountId: item.accountId,
//             companyId: item.companyId,
//             branchId: item.branchId,
//             costCenterId: item.costCenterId
//             // lineType: item.lineType,
//           }))
//         })
//       )
//         .unwrap()
//         .then((res: any) => {
//           if (res?.succeeded === true) {
//             CustomAlert({ action: 'Add' });
//             formik.resetForm();
//           } else {
//             formik.setSubmitting(false);
//             CustomAlert({ action: 'Error', msg: res?.message });
//           }
//         })
//         .catch((error: any) => {
//           formik.setSubmitting(false);
//           CustomAlert({ action: 'Error' });
//         });
//     }
//   });
//   const { values, handleChange: formikhandleChange, errors, touched } = formik;
//   //#endregion

//   const conversionRate = useConversionRateByLedgard({
//     LedgarId: values.ledgerId || '',
//     currencyCode: values.currencyCode,
//     date: values.glDate
//   });

//   const isDateValid = useCheckDateOnPeriod(values.glDate, values.periodId);

//   //#region Calculate the total debit and credit amounts
//   const totalEnteredDr = formik.values.JeLinesList.reduce((total, line) => total + line.enteredDr, 0);
//   const totalEnteredCr = formik.values.JeLinesList.reduce((total, line) => total + line.enteredCr, 0);
//   const totalAccountedDr = formik.values.JeLinesList.reduce((total, line) => total + line.accountDr, 0);
//   const totalAccountedCr = formik.values.JeLinesList.reduce((total, line) => total + line.accountCr, 0);
//   //#endregion

//   const getNameJournals = () => {
//     'manual +  periodId + jeCategory + jeSource';
//     const periodName = PeriodsList?.find(f => f.id === values.periodId)?.name;
//     const CategoryName = GlJeCategoryList?.find(f => f.id === values.jeCategory)?.name;
//     const SourceName = GlJeSourceList?.find(f => f.id === values.jeSource)?.name;

//     return `Manual + ${periodName} + ${CategoryName} + ${SourceName} `.trim();
//   };

//   return (
//     <div>
//       <div className='d-flex align-items-center'>
//         <Breadcrumb
//           BreadcrumbList={[
//             {
//               name: 'Home',
//               link: ':moduleHome'
//             },
//             {
//               name: 'القيود المالية',
//               link: '/Finance/Journals'
//             },
//             {
//               name: 'إضــافة قيـد',
//               link: null
//             }
//           ]}
//           PageName='إضـافة قيد جديد'
//           subtitle={ledgar?.name2}
//         />
//         <div className='ms-auto'></div>
//       </div>

//       <Loading
//         loading={loading1 || loading2 || loading3 || loading4 || loading5}
//         error={error1 || error2 || error3 || error4 || error5}
//       >
//         <Form onSubmit={formik.handleSubmit}>
//           <Card>
//             <CardBody>
//               <div className='row'>
//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('AccountingPeriod')}</label>
//                     <Form.Select
//                       className='form-select '
//                       name='periodId'
//                       onChange={formikhandleChange}
//                       value={values.periodId || ''}
//                       isInvalid={!!(touched.periodId && errors.periodId)}
//                       isValid={formik.touched.periodId && !formik.errors.periodId}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                       {GlPeriods &&
//                         GlPeriods?.map(item => (
//                           <option key={item.id} value={item.id}>
//                             {item.name}
//                           </option>
//                         ))}
//                     </Form.Select>
//                     <Form.Control.Feedback type='invalid'>{errors.periodId}</Form.Control.Feedback>
//                   </div>
//                 </div>

//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('Date')}</label>
//                     <Form.Control
//                       className='form-control  text-center'
//                       type='date'
//                       name='glDate'
//                       onChange={formikhandleChange}
//                       value={values.glDate || ''}
//                       isInvalid={!!(touched.glDate && errors.glDate)}
//                       isValid={formik.touched.glDate && !formik.errors.glDate}
//                     />
//                     <Form.Control.Feedback type='invalid'>{errors.glDate}</Form.Control.Feedback>
//                   </div>
//                 </div>
//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('Source')}</label>
//                     <Form.Select
//                       className='form-select'
//                       name='jeSource'
//                       onChange={formikhandleChange}
//                       value={values.jeSource || ''}
//                       isInvalid={!!(touched.jeSource && errors.jeSource)}
//                       isValid={formik.touched.jeSource && !formik.errors.jeSource}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                       {GlJeSourceList &&
//                         GlJeSourceList?.map(item => (
//                           <option key={item.id} value={item.id}>
//                             {i18n.language === 'en' ? item.name : item.name2}
//                           </option>
//                         ))}
//                     </Form.Select>
//                     <Form.Control.Feedback type='invalid'>{errors.jeSource}</Form.Control.Feedback>
//                   </div>
//                 </div>
//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('Category')}</label>
//                     <Form.Select
//                       className='form-select '
//                       name='jeCategory'
//                       onChange={formikhandleChange}
//                       value={values.jeCategory || ''}
//                       isInvalid={!!(touched.jeCategory && errors.jeCategory)}
//                       isValid={formik.touched.jeCategory && !formik.errors.jeCategory}
//                     >
//                       <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
//                       {GlJeCategoryList &&
//                         GlJeCategoryList?.map(item => (
//                           <option key={item.id} value={item.id}>
//                             {i18n.language === 'en' ? item.name : item.name2}
//                           </option>
//                         ))}
//                     </Form.Select>
//                     <Form.Control.Feedback type='invalid'>{errors.jeCategory}</Form.Control.Feedback>
//                   </div>
//                 </div>
//               </div>

//               <div className='row'>
//                 <div className='col-lg-3'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'> {t('Currency')} </label>
//                     <Form.Select
//                       disabled={values.JeLinesList?.length > 0}
//                       className='form-select'
//                       name='currencyCode'
//                       onChange={formikhandleChange}
//                       value={values.currencyCode || ''}
//                       isInvalid={!!(touched.currencyCode && errors.currencyCode)}
//                       isValid={formik.touched.currencyCode && !formik.errors.currencyCode}
//                     >
//                       {Currency &&
//                         Currency?.map((item: any, idx: number) => (
//                           <option key={++idx} value={item.currencyCode}>
//                             {item.description}
//                           </option>
//                         ))}
//                     </Form.Select>
//                   </div>
//                 </div>
//                 <div className='col-lg-2'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('ExchangeRate')}</label>
//                     <Form.Control
//                       disabled
//                       className='form-control text-center bg-inverse bg-opacity-15'
//                       type='text'
//                       autoComplete='off'
//                       name='currencyConversionRate'
//                       value={conversionRate || ''}
//                     />
//                   </div>
//                 </div>
//                 <div className='col-lg-7'>
//                   <div className='form-group mb-3'>
//                     <label className='form-label'>{t('البيــان')}</label>
//                     <Form.Control
//                       className='form-control'
//                       as='textarea'
//                       rows={1}
//                       name='description'
//                       onChange={formik.handleChange}
//                       value={values.description}
//                       isInvalid={!!(touched.description && errors.description)}
//                       isValid={touched.description && !errors.description}
//                     />
//                     <div></div>
//                   </div>
//                 </div>

//                 {/* <div className="col-lg-2 ">
//                 <div className="form-group mb-3">
//                   <label className="form-label">{t("conversionDate")}</label>
//                   <Form.Control
//                     disabled
//                     className="form-control text-center bg-inverse bg-opacity-15"
//                     type="date"
//                     name="conversionDate"
//                     value={conversionDate || ""}
//                   />
//                 </div>
//               </div> */}
//               </div>
//             </CardBody>
//           </Card>

//           <Card className='mt-3 shadow-sm border-0'>
//             {/* <CardBody> */}
//             <JournalLines2 formik={formik} ledgar={ledgar} />
//             {/* </CardBody> */}
//           </Card>
//           <Card className='mt-3 shadow p-1'>
//             <div className='text-center  '>
//               <button
//                 disabled={formik.isSubmitting || values.JeLinesList?.length === 0}
//                 type='button'
//                 className='btn btn-lg me-1 btn-warning  rounded-2'
//                 onClick={() => {
//                   setStateJu('T');
//                   formik.submitForm();
//                 }}
//               >
//                 <i className='fa fa-clock fa-fw me-1'></i>

//                 {t('TemporarySave')}
//               </button>
//               <button
//                 disabled={formik.isSubmitting || values.JeLinesList?.length === 0}
//                 type='button'
//                 className='btn btn-lg me-1 btn-theme  rounded-2'
//                 onClick={() => {
//                   setStateJu('U');
//                   formik.submitForm();
//                 }}
//               >
//                 {formik.isSubmitting ? (
//                   <div className='spinner-border spinner-border-sm me-2'></div>
//                 ) : (
//                   <i className='fa fa-save fa-fw me-1'></i>
//                 )}

//                 {t('Save')}
//               </button>
//               <button
//                 type='button'
//                 className='btn btn-lg me-1 btn-default rounded-2'
//                 onClick={() => navigate('/Finance/Journals', { replace: true })}
//               >
//                 <i className='fa fa-times fa-fw me-1'></i>

//                 {t('Cancel')}
//               </button>
//             </div>
//           </Card>
//         </Form>
//       </Loading>
//     </div>
//   );
// };

// export default AddJournals;

import { useEffect, useState } from 'react';
import { useAppDispatch } from '@store/hooks';
import { useFormik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Form, Modal } from 'react-bootstrap';
import Breadcrumb from '@components/Shared/Breadcrumb';
import useGetGlJeCategoryList from '@hooks/Finance/useGetGlJeCategoryList';
import useGetGlLedgersList from '@hooks/Finance/useGetGlLedgersList';
import useGetGlPeriodsList from '@hooks/Finance/GlPeriods/useGetGlPeriodsList';
import useLookupCurrency from '@hooks/Lookups/use-Lookup-Currency';
import { useNavigate } from 'react-router-dom';
import { type LedgersModels } from '@store/Finance/Ledgers/LedgersModels';
import { type GlJeLinesList } from '@store/Finance/Journals/JournalsModels';
import { AddGlJeHeaders } from '@store/Finance/Journals/JournalsSlice';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import SwalAlert from '@components/Shared/Alert/SwalAlert';
import JournalLines2 from '../JournalLines/JournalLines2';
import { Card, CardBody } from '@components/card/card';
import useConversionRateByLedgard from '@hooks/Finance/DailyRates/useConversionRateByLedgard';
import useCheckDateOnPeriod from '@hooks/Finance/GlPeriods/useCheckDateOnPeriod';
import Loading from '@components/Shared/Loader/Loading';
import Select from 'react-select';
import * as Yup from 'yup';
import useGetGlJeSourceList from '@hooks/Finance/useGetGlJeSourceList';

const emptyToUndef = (value: any, originalValue: any) => {
  // يسمح بالفارغ في الـ UI لكن يعتبره "غير مُدخل" في الفالديشن
  if (originalValue === '' || originalValue === null || originalValue === undefined) return undefined;
  const n = Number(originalValue);
  return Number.isNaN(n) ? undefined : n;
};

const AddGlJeHeaderSchema = (t: any) => {
  const requiredMsg = () => t('Required');

  const amountSchema = Yup.number().transform(emptyToUndef).typeError(requiredMsg()).min(0, requiredMsg());

  const lineSchema = Yup.object()
    .shape({
      lineType: Yup.string().oneOf(['credit', 'debit']).required(requiredMsg()),

      description: Yup.string().trim().required(requiredMsg()),

      accountId: Yup.string().nullable().required(requiredMsg()),

      enteredCr: amountSchema.when('lineType', {
        is: 'credit',
        then: s => s.required(requiredMsg()).moreThan(0, requiredMsg()),
        otherwise: s => s.test('credit-must-be-zero', requiredMsg(), v => v === undefined || Number(v) === 0)
      }),

      enteredDr: amountSchema.when('lineType', {
        is: 'debit',
        then: s => s.required(requiredMsg()).moreThan(0, requiredMsg()),
        otherwise: s => s.test('debit-must-be-zero', requiredMsg(), v => v === undefined || Number(v) === 0)
      })
    })
    .test('only-one-side', requiredMsg(), (line: any) => {
      // يمنع إدخال مدين ودائن معًا في نفس السطر
      const cr = Number(line?.enteredCr || 0);
      const dr = Number(line?.enteredDr || 0);
      return !(cr > 0 && dr > 0);
    });

  return Yup.object().shape({
    glDate: Yup.string().required(requiredMsg()),

    // description: Yup.string().trim().required(requiredMsg()),
    name2: Yup.string().trim().required(requiredMsg()),

    jeSource: Yup.string().notOneOf(['إختر', 'Choose'], 'Required').required(requiredMsg()),
    jeCategory: Yup.string().notOneOf(['إختر', 'Choose'], 'Required').required(requiredMsg()),

    periodId: Yup.string().notOneOf(['إختر', 'Choose'], 'Required').required(requiredMsg()),

    currencyCode: Yup.string().notOneOf(['إختر', 'Choose'], 'Required').required(requiredMsg()),

    // ✅ Validation للسطور
    JeLinesList: Yup.array().of(lineSchema).min(1, i18nFallback(t, 'Required')) // أو رسالة خاصة مثل: "يجب إضافة سطر واحد على الأقل"
  });
};

// لو ما عندك key لرسالة خاصة، خلّها Required
function i18nFallback(t: any, key: string) {
  try {
    return t(key);
  } catch {
    return key;
  }
}

const AddJournals = () => {
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const [stateJu, setStateJu] = useState<string>('T');
  const dispatch = useAppDispatch();

  // ✅ Modal state
  const [showSelectionModal, setShowSelectionModal] = useState(true);
  const [selectedLedger, setSelectedLedger] = useState<string>('');

  // Hooks
  const { Currency, loading: loading1, error: error1 } = useLookupCurrency();
  const { GlJeCategoryList, loading: loading2, error: error2, OptionsJeCategory } = useGetGlJeCategoryList();
  const { OptionsJeSource, GlJeSourceList, loading: loading3, error: error3 } = useGetGlJeSourceList();
  const { LedgersList, OptionsLedgers, loading: loading4, error: error4 } = useGetGlLedgersList();
  const { PeriodsList, GlPeriods, loading: loading5, error: error5 } = useGetGlPeriodsList();

  const [ledgar, setLedgar] = useState<LedgersModels | undefined>(undefined);

  // ✅ تعيين الأستاذ العام الأول كافتراضي عند توفر الخيارات
  useEffect(() => {
    if (
      OptionsLedgers &&
      OptionsLedgers.length > 0 &&
      !selectedLedger && // فقط إذا لم يكن هناك اختيار سابق
      !loading4 // نتأكد أن التحميل انتهى
    ) {
      setSelectedLedger(OptionsLedgers[0].value);
    }
  }, [OptionsLedgers, selectedLedger, loading4]);

  // ✅ تحديث الـ ledger عند اختياره من المودال
  useEffect(() => {
    if (LedgersList && selectedLedger) {
      const foundLedger = LedgersList?.find(ledger => ledger.id === selectedLedger);
      if (foundLedger) {
        setLedgar(foundLedger);
        // setShowSelectionModal(false);
      }
    }
  }, [LedgersList, selectedLedger]);

  // ✅ تأكيد الاختيار من المودال
  const handleSelectionConfirm = () => {
    if (!selectedLedger) {
      SwalAlert({ text: 'يجب اختيار أستاذ عام أولاً' });
      return;
    }

    const foundLedger = LedgersList?.find(ledger => ledger.id === selectedLedger);
    if (foundLedger) {
      setLedgar(foundLedger);
      setShowSelectionModal(false);
    }
  };

  //#region Formik
  const formik = useFormik({
    initialValues: {
      glDate: new Date().toISOString().split('T')[0],
      ledgerId: selectedLedger || '',
      jeCategory: '',
      jeSource: '',
      periodId: '',
      name: '',
      name2: '',
      status: '',

      currencyCode: ledgar ? ledgar?.currencyCode : 'SAR',
      conversionFlag: false,
      currencyConversionRate: 1,
      conversionDate: '',

      reverseFlag: false,
      jeBatchId: null,
      parentJeHeaderId: null,
      postedDate: '',
      description: '',
      accountedDr: 0,
      accountedCr: 0,
      enteredDr: 0,
      enteredCr: 0,
      JeLinesList: [] as GlJeLinesList[]
    },
    enableReinitialize: true,
    validationSchema: AddGlJeHeaderSchema(t),
    onSubmit: values => {
      if (!selectedLedger) {
        SwalAlert({ text: 'يجب اختيار أستاذ عام أولاً' });
        formik.setSubmitting(false);
        return;
      }

      if (values.JeLinesList?.length === 0) {
        SwalAlert({ text: 'There is no Data' });
        formik.setSubmitting(false);
        return;
      }

      if (!isDateValid) {
        SwalAlert({ text: 'التاريـخ ليس ضمن الفترة المحاسبية' });
        formik.setSubmitting(false);
        return;
      }

      if (stateJu === 'U' && Number(totalEnteredDr) !== Number(totalEnteredCr)) {
        SwalAlert({ text: 'يجب ان يتساوى الدائن والمديـن' });
        formik.setSubmitting(false);
        return;
      }

      dispatch(
        AddGlJeHeaders({
          glDate: values.glDate,
          ledgerId: selectedLedger || '',
          jeCategory: values.jeCategory,
          // jeSource: values.jeSource,
          jeSource: null,
          periodId: values.periodId,
          // name: getNameJournals(),
          name2: values.name2,
          name: values.name ?? values.name2,
          status: stateJu,
          currencyCode: values.currencyCode,
          conversionFlag: values.currencyCode !== ledgar?.currencyCode,
          currencyConversionRate: conversionRate,
          conversionDate: null,
          jeBatchId: values.jeBatchId,
          parentJeHeaderId: values.parentJeHeaderId,
          postedDate: new Date().toISOString().split('T')[0],
          description: values.description,
          accountedDr: Number(totalAccountedDr),
          accountedCr: Number(totalAccountedCr),
          enteredDr: Number(totalEnteredDr),
          enteredCr: Number(totalEnteredCr),
          glJeLinesList: values.JeLinesList?.map(item => ({
            jeLineNum: Number(item.jeLineNum),
            enteredDr: Number(item.enteredDr) || 0,
            enteredCr: Number(item.enteredCr) || 0,
            accountDr: Number(item.accountDr) || 0,
            accountCr: Number(item.accountCr) || 0,
            description: item.description,
            accountId: item.accountId,
            companyId: item.companyId,
            branchId: item.branchId,
            costCenterId: item.costCenterId
          }))
        })
      )
        .unwrap()
        .then((res: any) => {
          if (res?.succeeded === true) {
            CustomAlert({ action: 'Add' });
            navigate('/Finance/Journals', { replace: true });
          } else {
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          CustomAlert({ action: 'Error' });
        })
        .finally(() => formik.setSubmitting(false));
    }
  });

  const { values, handleChange: formikhandleChange, errors, touched } = formik;
  //#endregion
  // console.log(values);

  const conversionRate = useConversionRateByLedgard({
    LedgarId: selectedLedger || '',
    currencyCode: values.currencyCode,
    date: values.glDate
  });

  const isDateValid = useCheckDateOnPeriod(values.glDate, values.periodId);

  //#region Calculate the total debit and credit amounts
  const totalEnteredDr = formik.values.JeLinesList.reduce((total, line) => total + line.enteredDr, 0);
  const totalEnteredCr = formik.values.JeLinesList.reduce((total, line) => total + line.enteredCr, 0);
  const totalAccountedDr = formik.values.JeLinesList.reduce((total, line) => total + line.accountDr, 0);
  const totalAccountedCr = formik.values.JeLinesList.reduce((total, line) => total + line.accountCr, 0);
  //#endregion

  const getNameJournals = () => {
    const periodName = PeriodsList?.find(f => f.id === values.periodId)?.name;
    const CategoryName = GlJeCategoryList?.find(f => f.id === values.jeCategory)?.name;
    // const SourceName = GlJeSourceList?.find(f => f.id === values.jeSource)?.name;

    // return `Manual + ${periodName} + ${CategoryName} + ${SourceName} `.trim();
    return `Manual + ${periodName} + ${CategoryName}`.trim();
  };

  const fieldNames: Record<string, string> = {
    periodId: 'الفترة المحاسبية',
    jeSource: 'المصدر',
    jeCategory: 'التصنيف',
    ledgerId: 'الأستاذ العام',
    glDate: 'التاريخ',
    // description: 'البيان',
    name2: 'البيان',
    currencyCode: 'العملة'
    // إذا أردت إضافة رسائل للحقول الفرعية داخل السطور (قد تكون معقدة)
    // يمكنك تجاهلها حالياً لأنها ستظهر كـ "JeLinesList" بشكل افتراضي
  };

  return (
    <div>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
              link: ':moduleHome'
            },
            {
              name: 'القيود المالية',
              link: '/Finance/Journals'
            },
            {
              name: 'إضــافة قيـد',
              link: null
            }
          ]}
          PageName='إضـافة قيد جديد'
          subtitle={ledgar?.name2}
        />
        <div className='ms-auto'></div>
      </div>

      {/* ✅ Modal اختيار الأستاذ العام */}
      <Modal show={showSelectionModal} backdrop='static' keyboard={false} centered className='modal-selection-theme'>
        <Modal.Header className='bg-theme bg-opacity-30 text-white py-3'>
          <Modal.Title className='text-center w-100 h5'>
            <i className='fas fa-book me-2'></i>
            {t('اختيار الأستاذ العام')}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className='p-4'>
          <div className='row'>
            <div className='col-12'>
              <label className='form-label fw-bold'>
                <i className='fas fa-book-open me-2 text-theme'></i>
                {t('الأستاذ العام')}
              </label>
              <div className='input-group'>
                <span className='input-group-text bg-inverse bg-opacity-25 border-end-0'>
                  <i className='fas fa-book text-theme'></i>
                </span>

                <Select
                  classNamePrefix='react-select'
                  isLoading={loading4}
                  isSearchable={true}
                  isClearable
                  options={OptionsLedgers}
                  value={OptionsLedgers.find(f => f.value === selectedLedger)}
                  onChange={(option: any) => setSelectedLedger(option?.value || '')}
                  placeholder={i18n.language === 'ar' ? 'اختر الأستاذ العام' : 'Choose General Ledger'}
                  className='flex-grow-1'
                  noOptionsMessage={() => (i18n.language === 'ar' ? 'لا توجد بيانات' : 'No data available')}
                  loadingMessage={() => (i18n.language === 'ar' ? 'جاري التحميل...' : 'Loading...')}
                  formatOptionLabel={(option: any) => (
                    <div className='d-flex justify-content-between align-items-center'>
                      <span>{option.label}</span>
                      <small className='text-muted'>{option.currency}</small>
                    </div>
                  )}
                />
              </div>
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer className='justify-content-center border-top-0 pt-0'>
          <button
            className='btn btn-outline-secondary btn-lg px-4 py-2 me-3 rounded-1'
            onClick={() => navigate('/Finance/Journals')}
          >
            <i className='fas fa-times me-2'></i>
            {t('إلغاء')}
          </button>

          <button
            className='btn btn-theme btn-lg px-5 py-2 rounded-1'
            onClick={handleSelectionConfirm}
            disabled={!selectedLedger || loading4}
          >
            {loading4 ? (
              <>
                <div className='spinner-border spinner-border-sm me-2'></div>
                {t('جاري التحميل...')}
              </>
            ) : (
              <>
                <i className='fas fa-check-circle me-2'></i>
                {t('استمرار')}
              </>
            )}
          </button>
        </Modal.Footer>
      </Modal>

      <Loading loading={loading1 || loading2 || loading4 || loading5} error={error1 || error2 || error4 || error5}>
        {!showSelectionModal && (
          <Form onSubmit={formik.handleSubmit}>
            <Card>
              <CardBody>
                <div className='row'>
                  <div className='col-lg-4'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('الأستاذ العام')}</label>
                      <Select
                        isDisabled
                        classNamePrefix='react-select'
                        isLoading={loading4}
                        isSearchable={true}
                        options={OptionsLedgers}
                        value={OptionsLedgers.find(f => f.value === selectedLedger)}
                        placeholder={i18n.language === 'ar' ? 'الأستاذ العام المختار' : 'Selected Ledger'}
                      />
                    </div>
                  </div>

                  <div className='col-lg-4'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('AccountingPeriod')}</label>
                      <Form.Select
                        className='form-select '
                        name='periodId'
                        onChange={formikhandleChange}
                        value={values.periodId || ''}
                        isInvalid={!!(touched.periodId && errors.periodId)}
                        // isValid={formik.touched.periodId && !formik.errors.periodId}
                      >
                        <option value=''>{i18n.language === 'ar' ? 'إختر' : 'Choose'}</option>
                        {GlPeriods &&
                          GlPeriods?.map(item => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                      </Form.Select>
                      <Form.Control.Feedback type='invalid'>{errors.periodId}</Form.Control.Feedback>
                    </div>
                  </div>

                  <div className='col-lg-4'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('Date')}</label>
                      <Form.Control
                        className='form-control  text-center'
                        type='date'
                        name='glDate'
                        onChange={formikhandleChange}
                        value={values.glDate || ''}
                        isInvalid={!!(touched.glDate && errors.glDate)}
                        // isValid={formik.touched.glDate && !formik.errors.glDate}
                      />
                      <Form.Control.Feedback type='invalid'>{errors.glDate}</Form.Control.Feedback>
                    </div>
                  </div>

                  <div className='col-lg-4'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('Source')}</label>

                      <Select
                        classNamePrefix='react-select'
                        isLoading={loading3}
                        isSearchable={true}
                        isClearable
                        options={OptionsJeSource}
                        onChange={(option: any) => formik.setFieldValue('jeSource', option?.value || '')}
                        placeholder={i18n.language === 'ar' ? 'اختر' : 'Choose'}
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                        }}
                      />
                    </div>
                  </div>

                  <div className='col-lg-4'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('Category')}</label>

                      <Select
                        classNamePrefix='react-select'
                        isLoading={loading4}
                        isSearchable={true}
                        isClearable
                        options={OptionsJeCategory}
                        onChange={(option: any) => formik.setFieldValue('jeCategory', option?.value || '')}
                        placeholder={i18n.language === 'ar' ? 'اختر' : 'Choose'}
                        // className='flex-grow-1'
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base: any) => ({ ...base, zIndex: 9999 })
                        }}
                      />

                      <Form.Control.Feedback type='invalid'>{errors.jeCategory}</Form.Control.Feedback>
                    </div>
                  </div>

                  <div className='col-lg-2'>
                    <div className='form-group mb-3'>
                      <label className='form-label'> {t('Currency')} </label>
                      <Form.Select
                        disabled={values.JeLinesList?.length > 0}
                        className='form-select'
                        name='currencyCode'
                        onChange={formikhandleChange}
                        value={values.currencyCode || ledgar?.currencyCode || 'SAR'}
                        isInvalid={!!(touched.currencyCode && errors.currencyCode)}
                        // isValid={formik.touched.currencyCode && !formik.errors.currencyCode}
                      >
                        {Currency &&
                          Currency?.map((item: any, idx: number) => (
                            <option key={++idx} value={item.currencyCode}>
                              {item?.description}
                            </option>
                          ))}
                      </Form.Select>
                    </div>
                  </div>

                  <div className='col-lg-2'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('ExchangeRate')}</label>
                      <Form.Control
                        disabled
                        className='form-control text-center bg-inverse bg-opacity-15'
                        type='text'
                        autoComplete='off'
                        name='currencyConversionRate'
                        value={conversionRate || ''}
                      />
                    </div>
                  </div>

                  <div className='col-lg-6'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('البيان (محلي)')}</label>
                      <Form.Control
                        className='form-control'
                        as='textarea'
                        rows={1}
                        name='name2'
                        onChange={formik.handleChange}
                        value={values.name2}
                        isInvalid={!!(touched.name2 && errors.name2)}
                        // isValid={touched.description && !errors.description}
                      />
                    </div>
                  </div>
                  <div className='col-lg-6'>
                    <div className='form-group mb-3'>
                      <label className='form-label'>{t('البيان (عالمي)')}</label>
                      <Form.Control
                        className='form-control'
                        as='textarea'
                        rows={1}
                        name='name'
                        onChange={formik.handleChange}
                        value={values.name}
                        isInvalid={!!(touched.name && errors.name)}
                      />
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>

            <Card className='mt-3 shadow-sm border-0'>
              <JournalLines2 formik={formik} ledgar={ledgar} />
            </Card>

            {Object.keys(formik.errors)?.length > 0 && (
              <div className='alert alert-danger mt-3 border rounded-2 shadow-sm' role='alert'>
                <h6 className='mb-1 text-danger'>
                  <i className='bi bi-exclamation-triangle-fill me-2'></i>
                  {i18n.language === 'en' ? 'Please review the following fields:' : '  يُرجى مراجعة الحقول التالية:'}
                </h6>
                <ul className='mb-0 ps-4 mt-2'>
                  {Object?.entries(formik?.errors)?.map(([field, error]: any) => {
                    // تجاهل أخطاء المصفوفات (مثل JeLinesList) لأنها تحتوي على كائنات
                    if (field === 'JeLinesList' || typeof error === 'object') {
                      return null;
                    }

                    return (
                      <li key={field} className='small'>
                        <strong>{fieldNames[field] ?? field}:</strong> <span className='fw-normal'>{error}</span>
                      </li>
                    );
                  })}
                </ul>

                {/* رسالة منفصلة لأخطاء السطور */}
                {formik.errors.JeLinesList && (
                  <div className='mt-2 small text-warning'>
                    <i className='bi bi-exclamation-circle me-1'></i>
                    {i18n.language === 'ar'
                      ? 'يوجد خطأ في بيانات السطور - يرجى مراجعة السطور للتأكد من إدخال جميع البيانات المطلوبة بشكل صحيح'
                      : 'There is an error in the journal lines - please review the lines to ensure all required data is entered correctly'}
                  </div>
                )}
              </div>
            )}

            {/* {Object.keys(formik.errors)?.length > 0 && (
              <div className='alert alert-danger mt-3 border rounded-2 shadow-sm' role='alert'>
                <h6 className='mb-1 text-danger'>
                  <i className='bi bi-exclamation-triangle-fill me-2'></i>
                  {i18n.language === 'en' ? 'Please review the following fields:' : '  يُرجى مراجعة الحقول التالية:'}
                </h6>
                <ul className='mb-0 ps-4 mt-2'>
                  {Object?.entries(formik?.errors)?.map(([field, error]: any) => (
                    <li key={field} className='small'>
                      <strong>{fieldNames[field] ?? field}:</strong> <span className='fw-normal'>{error}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )} */}

            <Card className='mt-3 shadow p-1'>
              <div className='text-center'>
                <button
                  disabled={formik.isSubmitting || values.JeLinesList?.length === 0}
                  type='button'
                  className='btn btn-lg me-1 btn-warning rounded-2'
                  onClick={() => {
                    setStateJu('T');
                    formik.submitForm();
                  }}
                >
                  <i className='fa fa-clock fa-fw me-1'></i>
                  {t('TemporarySave')}
                </button>

                <button
                  disabled={formik.isSubmitting || values.JeLinesList?.length === 0}
                  type='button'
                  className='btn btn-lg me-1 btn-theme rounded-2'
                  onClick={() => {
                    setStateJu('U');
                    formik.submitForm();
                  }}
                >
                  {formik.isSubmitting ? (
                    <div className='spinner-border spinner-border-sm me-2'></div>
                  ) : (
                    <i className='fa fa-save fa-fw me-1'></i>
                  )}
                  {t('Save')}
                </button>

                <button
                  type='button'
                  className='btn btn-lg me-1 btn-default rounded-2'
                  onClick={() => navigate('/Finance/Journals', { replace: true })}
                >
                  <i className='fa fa-times fa-fw me-1'></i>
                  {t('Cancel')}
                </button>
              </div>
            </Card>
          </Form>
        )}
      </Loading>
    </div>
  );
};

export default AddJournals;
